import { render, staticRenderFns } from "./ReturnToCustomer.vue?vue&type=template&id=8a410cda&"
import script from "./ReturnToCustomer.vue?vue&type=script&lang=js&"
export * from "./ReturnToCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports